// Real product catalog from Jelly by Enkor — official packshots
export const PRODUCTS = [
  {
    slug: 'protector-solar',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/qzdb6627_Photoroom_20260609_051831.jpeg',
    color: '#F0F7FB',
    accent: '#7CC1DE',
    name: { es: 'Sun Suavecito · Protector Solar', en: 'Sun Suavecito · Sunscreen' },
    tagline: { es: 'Protégeme un poquito · SPF 50', en: 'Protégeme un poquito · SPF 50' },
    description: {
      es: 'Protector solar en barra SPF 50 con acabado suave y luminoso. Se desliza en segundos, no deja rastros blancos y prepara la piel para el maquillaje. Tu dosis diaria de glow al alcance de tu bolsillo.',
      en: 'SPF 50 stick sunscreen with a soft luminous finish. Glides in seconds, leaves no white cast and preps skin for makeup. Your daily dose of glow on the go.',
    },
    ingredients: {
      es: ['Niacinamida', 'Ácido Hialurónico', 'Extracto de pepino', 'Vitamina E'],
      en: ['Niacinamide', 'Hyaluronic Acid', 'Cucumber Extract', 'Vitamin E'],
    },
    howTo: {
      es: 'Desliza directamente sobre el rostro como último paso de tu rutina, antes del maquillaje. Reaplica cada 2 horas bajo el sol.',
      en: 'Glide directly on the face as the last step of your routine, before makeup. Reapply every 2 hours under direct sun.',
    },
    shades: [{ label: 'Único', ref: '33392' }],
    price: '$40.000 COP',
  },
  {
    slug: 'base-liquida',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/zq1ld1tk_Photoroom_20260609_051701.jpeg',
    color: '#F1ECF9',
    accent: '#B57CD8',
    name: { es: 'Zero Drama Mama! · Base Líquida', en: 'Zero Drama Mama! · Liquid Foundation' },
    tagline: { es: 'Base líquida SPF 20 · N°5', en: 'Liquid foundation SPF 20 · N°5' },
    description: {
      es: 'Base de maquillaje líquida para el rostro que unifica el tono de la piel, disimula imperfecciones y deja un acabado fresco tipo skin filter. 30ml de drama cero, glow máximo.',
      en: 'Liquid foundation that evens skin tone, blurs imperfections and leaves a fresh skin-filter finish. 30ml of zero drama and maximum glow.',
    },
    ingredients: {
      es: ['Escualano', 'Centella Asiática', 'Vitamina B5', 'SPF 20'],
      en: ['Squalane', 'Centella Asiatica', 'Vitamin B5', 'SPF 20'],
    },
    howTo: {
      es: 'Aplica una pequeña cantidad con esponja húmeda o brocha desde el centro del rostro hacia afuera. Construye cobertura por capas.',
      en: 'Apply a small amount with a damp sponge or brush from the center of the face outward. Build coverage in layers.',
    },
    shades: [
      { label: 'N°1', ref: '33421' },
      { label: 'N°2', ref: '33423' },
      { label: 'N°3', ref: '33424' },
      { label: 'N°4', ref: '33425' },
      { label: 'N°5', ref: '33427' },
    ],
    price: '$26.000 COP',
  },
  {
    slug: 'polvo-compacto',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/vo1px2nx_Photoroom_20260609_052104.jpeg',
    color: '#FCEEE3',
    accent: '#C95F4A',
    name: { es: 'Filtro Real · Polvo Compacto', en: 'Filtro Real · Pressed Powder' },
    tagline: { es: 'Toque final · SPF 30 · N°2', en: 'Final touch · SPF 30 · N°2' },
    description: {
      es: 'Polvo compacto SPF 30 que da el toque final tipo "filtro real". Fija el maquillaje, matifica zonas brillantes y suaviza la piel sin marcar líneas. Para que la cámara te quiera todavía más.',
      en: 'Pressed powder SPF 30 that delivers a real-filter final touch. Sets makeup, mattifies shiny areas and softens skin without creasing. So the camera loves you even more.',
    },
    ingredients: {
      es: ['Polvo de arroz', 'Polvo de seda', 'Vitamina E', 'SPF 30'],
      en: ['Rice powder', 'Silk powder', 'Vitamin E', 'SPF 30'],
    },
    howTo: {
      es: 'Aplica con la esponja o brocha incluida sobre la zona T y donde necesites fijar. Reaplica durante el día para refrescar el look.',
      en: 'Apply with the included sponge or brush on the T-zone and where you need to set. Reapply during the day to refresh the look.',
    },
    shades: [
      { label: 'N°1', ref: '33395' },
      { label: 'N°2', ref: '33397' },
      { label: 'N°3', ref: '33403' },
      { label: 'N°4', ref: '33408' },
      { label: 'N°5', ref: '33415' },
      { label: 'N°6', ref: '33416' },
      { label: 'N°7', ref: '33419' },
    ],
    price: '$25.000 COP',
  },
  {
    slug: 'balsamo-labial',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/pctjjcil_Photoroom_20260609_052332.jpeg',
    color: '#FDE7E0',
    accent: '#F08272',
    name: { es: 'S.O.S Labios · Bálsamo Labial', en: 'S.O.S Lips · Lip Balm' },
    tagline: { es: 'SPF 20 · hidratación 12h', en: 'SPF 20 · 12h hydration' },
    description: {
      es: 'Bálsamo labial con SPF 20 y un toque de tinte tipo jelly. Hidrata profundamente, protege del sol y deja un acabado glossy adictivo. Para llevar siempre en el bolsillo.',
      en: 'Lip balm with SPF 20 and a jelly-like hint of tint. Deeply hydrates, protects from the sun and leaves an addictive glossy finish. Pocket-sized essential.',
    },
    ingredients: {
      es: ['Manteca de karité', 'Aceite de jojoba', 'Ácido hialurónico', 'SPF 20'],
      en: ['Shea butter', 'Jojoba oil', 'Hyaluronic acid', 'SPF 20'],
    },
    howTo: {
      es: 'Aplica directamente en los labios. Repite cuando quieras un toque extra de color, hidratación o protección.',
      en: 'Apply directly on lips. Reapply whenever you want an extra touch of colour, hydration or protection.',
    },
    shades: [{ label: 'Único', ref: '33440' }],
    price: '$12.000 COP',
  },
  {
    slug: 'rubor',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/2yvc1zbg_Photoroom_20260609_052421.jpeg',
    color: '#FFE0EB',
    accent: '#E03B6A',
    name: { es: 'Pinch Me Baby · Rubor en Polvo', en: 'Pinch Me Baby · Pressed Blush' },
    tagline: { es: 'Pressed blush · acabado mate o satinado', en: 'Pressed blush · matte or satin finish' },
    description: {
      es: 'Rubor en polvo que proporciona un acabado mate o satinado, super pigmentado y modulable. Difumina como un sueño y deja mejillas tipo "pinch" recién despertada. Bueno, bonito y barato — las 3B Jelly.',
      en: 'Pressed blush with a matte or satin finish, super pigmented and buildable. Blends like a dream and leaves cheeks looking pinched and freshly awake. Good, cute and affordable — the Jelly 3B.',
    },
    ingredients: {
      es: ['Glicerina', 'Aceite de almendras', 'Mica natural', 'Vitamina E'],
      en: ['Glycerin', 'Almond oil', 'Natural mica', 'Vitamin E'],
    },
    howTo: {
      es: 'Aplica con brocha sobre las mejillas, difuminando hacia las sienes. Capas ligeras para un look natural, capas extra para un look fuerte.',
      en: 'Apply with a brush on the cheeks, blending toward the temples. Light layers for a natural look, extra layers for a bold look.',
    },
    shades: [
      { label: 'N°1', ref: '33432' },
      { label: 'N°2', ref: '33438' },
      { label: 'N°3', ref: '33439' },
    ],
    price: '$15.000 COP',
  },
  {
    slug: 'cosmetiquera',
    image: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/tgw9i22v_IMG-20260601-WA1417.jpg',
    color: '#F4E6F8',
    accent: '#A99BE0',
    name: { es: 'Jelly Bag · Cosmetiquera Set', en: 'Jelly Bag · Cosmetic Pouch Set' },
    tagline: { es: 'Tote tejida + cosmetiqueras peluche & quilted', en: 'Knitted tote + plush & quilted pouches' },
    description: {
      es: 'El set de cosmetiqueras Jelly: una tote tejida en checkered amarillo y rosa con el logo bordado, una cosmetiquera de peluche rosa con etiqueta colgante y una cosmetiquera quilted en lila. Para llevar tus Jellys a todas partes con mucho estilo Y2K.',
      en: 'The Jelly pouch set: a checkered knitted tote in yellow and pink with embroidered logo, a plush pink cosmetic pouch with a hang tag, and a lilac quilted pouch. Carry your Jellys everywhere with Y2K style.',
    },
    ingredients: {
      es: ['Tejido suave', 'Peluche premium', 'Forro quilted lila', 'Cremalleras metálicas'],
      en: ['Soft knit', 'Premium plush', 'Lilac quilted lining', 'Metal zippers'],
    },
    howTo: {
      es: 'Úsalas para guardar tu set Jelly, productos del día a día o como accesorio para combinar con tu outfit. Edición limitada.',
      en: 'Use them to store your Jelly set, daily essentials or as a styling accessory. Limited edition.',
    },
    shades: [
      { label: 'Pink Knit Tote', ref: '' },
      { label: 'Plush Pink Pouch', ref: '' },
      { label: 'Lilac Quilted Pouch', ref: '' },
    ],
    price: '$28',
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
